export function TargetIcon({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="28"
                cy="28"
                r="24"
                stroke="url(#paint0_linear_target)"
                strokeWidth="2"
            />
            <circle
                cx="28"
                cy="28"
                r="16"
                stroke="url(#paint1_linear_target)"
                strokeWidth="2"
            />
            <circle
                cx="28"
                cy="28"
                r="8"
                stroke="url(#paint2_linear_target)"
                strokeWidth="2"
            />
            <circle
                cx="28"
                cy="28"
                r="3"
                fill="url(#paint3_linear_target)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_target"
                    x1="28"
                    y1="4"
                    x2="28"
                    y2="52"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#667eea" />
                    <stop offset="1" stopColor="#764ba2" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_target"
                    x1="28"
                    y1="12"
                    x2="28"
                    y2="44"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#667eea" />
                    <stop offset="1" stopColor="#764ba2" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_target"
                    x1="28"
                    y1="20"
                    x2="28"
                    y2="36"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#667eea" />
                    <stop offset="1" stopColor="#764ba2" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_target"
                    x1="28"
                    y1="25"
                    x2="28"
                    y2="31"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#667eea" />
                    <stop offset="1" stopColor="#764ba2" />
                </linearGradient>
            </defs>
        </svg>
    );
}
